import ToolModule from "@/store/modules/tool.module";
import { Machine } from "xstate";
// export type toolEvents = deleteTool ;
const ToolsMachine = Machine({
    id: "ToolsMachine",
    initial: "idle",
    states: {
        idle: {
            always: { target: "gettingToolsList" },
        },
        gettingToolsList: {
            invoke: {
                id: "gettingToolsListView",
                src: () => ToolModule.GetTools(),
                onDone: { target: "loadedToolsList" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedToolsList: {},
        serviceUnavailable: {
            type: "final",
        }
    },
});
export default ToolsMachine;
